import Pane from './Pane.js'

/**
 * Single value pane
 *
 * @param {Object} props
 * @param {Boolean} props.isLoading
 * @param {String} props.title
 * @param {React.ReactNode} props.children
 * @returns {React.ReactNode}
 */
export default function SingleValuePane({isLoading, title, children}) {
  return (
    <Pane title={title} isLoading={isLoading}>
      {children ? (
        <p className="fs-03 margin-top-15 margin-bottom-15">{children}</p>
      ) : (
        <dl className="list list--horiz-bar-graph centered-text hide-for-loading">
          <dt className="list__item margin-bottom-0 make-medium-dark-grey">
            <strong>There is no data to display</strong>
          </dt>
        </dl>
      )}
    </Pane>
  )
}
